<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>

      <!-- 开始企业版 -->
      <section v-if="datas.business.rootid == 100010022">
        <header class="headerOne">
          <div class="header" :class="{ 'fix': headOne }"><a class="header-main" v-text="datas.business.name"></a></div>
        </header>

        <div class="swiper-container banner bannerOne" v-if="datas.focus && datas.focus_pics_is_show == 1">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in datas.focus" v-bind:key="index"><img :src="item.img">
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
        <div v-if="datas.video" class="box-list-img" style="margin-top: 10px;">
          <video id="VideoBox" class="video-js vjs-big-play-centered vjs-fluid VideoBox" :poster="datas.product.img">
            <source :src="datas.video.url" type="video/mp4">
          </video>
        </div>

        <div class="box">
          <div class="box-bg box-radius">
            <div class="box-head">产品信息</div>
            <div class="box-list padding-box">
              <ul>
                <li class="box-list-left">商品名称：</li>
                <li class="box-list-right" v-text="datas.product.name"></li>
              </ul>
            </div>
          </div>
        </div>

        <!-- <div class="box">
      	<div class="box-bg box-radius">
      		<div class="box-head">商户信息</div>
      		<div class="box-list padding-box">
      			<ul>
      				<li class="box-list-left">商户名称：</li>
      				<li class="box-list-right" v-text="organize.org.name"></li>
      			</ul>
      			<ul>
      				<li class="box-list-left">商户地址：</li>
      				<li class="box-list-right" v-text="organize.org.linkaddress"></li>
      			</ul>
      		</div>
      	</div>
      </div> -->

        <div class="box" v-if="datas.batch">
          <div class="box-bg box-radius">
            <div class="box-head">质检信息</div>
            <div class="box-list customize">
              <div class="box-list-main" v-for="item in datas.batch.qc">
                <div class="box-list-title">
                  <ul>
                    <li class="box-list-left title-color" v-text="item.key"></li>
                    <li class="box-list-right">
                      <img class="box-list-right-icon" src="../../static/images/Normal05/right.svg">
                    </li>
                  </ul>
                </div>
                <div class="box-list-datas" v-if="item.value && item.value.length > 0">
                  <div v-if="item.key == '五、屠宰厂信息'">
                    <!-- <header class="headerOne">
                  	<div class="header"><a class="header-main" v-text="datas.batch.name"></a></div>
                  </header> -->
                  </div>
                  <ul v-for="vall in item.value">
                    <li v-if="vall.ix == 0" class="box-list-left" v-text="vall.key"></li>
                    <li v-if="vall.ix == 0" class="box-list-right" v-text="vall.value"></li>
                    <li v-if="vall.ix == 1"><img class="img" :src="vall.value" /></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 企业信息是否显示 -->
        <section v-if="datas.business && datas.business_is_show == 1">
          <header class="headerTwo">
            <div class="header" :class="{ 'fix': headTwo }" :style="{ backgroundColor: navColor }"><a
                class="header-main" v-text="datas.business.name"></a></div>
          </header>

          <div class="swiper-container banner bannerTwo" v-if="datas.focus && datas.focus_pics_is_show == 1">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in datas.focus" v-bind:key="index"><img :src="item.img">
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>

          <div class="box-main box-bg box-top">
            <div class="SearchReturn" v-if="datas.scan_count > 1">您查询的商品编码为<i class="code"
                v-text="code"></i>，此编码已被查询过，谨防假冒！</div>
            <div class="SearchReturn" v-else>你查询的编码为<i class="code" v-text="code"></i>，是 {{ datas.business.name }}
              的正牌产品，首次被查询，请放心使用!</div>
            <div class="box-list">
              <ul style="padding-bottom: 5px;">
                <li class="box-list-left">查询次数：</li>
                <li class="box-list-right" v-text="datas.scan_count"></li>
                <li class="box-list-btn" :style="{ backgroundColor: navColor }" @click="ViewMore(1)">查询记录</li>
              </ul>
              <ul>
                <li class="box-list-left">首查时间：</li>
                <li class="box-list-right" v-text="datas.scan_first_time"></li>
              </ul>
            </div>
          </div>

          <div class="box-main box-bg box-top" v-if="datas.ref && datas.ref.length > 0 && datas.ref_is_show == 1">
            <div class="btn-arr" :style="{ height: btnarrheight + 'px' }">
              <div class="btn-style" :style="{ top: item.top + 'px', left: item.left, opacity: item.opaque }"
                v-on:click="RefJump(index)" v-for="(item, index) in datas.ref" :class="item.color"
                v-if="index < 5 || isShow">
                <a v-text="item.name"></a>
                <img class="btn-icon" src="../../static/images/Normal05/right-two.svg">
              </div>
              <div class="btn-style orange-two-bg" :style="{ top: btntop + 'px', left: btnleft, opacity: btnopaque }"
                v-on:click="MoreBtn" v-if="!isShow">
                <a>查看更多</a>
                <img class="btn-icon" src="../../static/images/Normal05/plus.svg">
              </div>
            </div>
          </div>

          <!-- <div class="box-main box-bg box-top" v-if="datas.menu && datas.menu.length > 0 && datas.menu_is_show == 1">
          <div class="btn-arr">
            <div class="btn-style-two red-bg" v-for="(val,index) in datas.menu" v-on:click="MenuJump(val.url)">
            	<a v-text="val.name"></a>
            	<img class="btn-icon" src="../../static/images/Normal05/right-two.svg">
            </div>
          </div>
        </div> -->

          <div class="box-main box-bg box-top" v-if="datas.product && datas.product.introduce">
            <div class="btn-arr">
              <div class="btn-style-two red-bg" v-on:click="MenuJump(datas.product.introduce)">
                <a>查看详情</a>
                <img class="btn-icon" src="../../static/images/Normal05/right-two.svg">
              </div>
            </div>
          </div>

          <div class="box-main box-bg box-top">
            <div class="box-head-two"><a>联系我们</a></div>
            <div class="box-company-name">
              <a>公司名称</a>
              <a v-text="datas.business.name"></a>
            </div>
            <div class="separation"></div>
            <div class="box-connect">
              <img class="box-connect-user" src="../../static/images/Normal05/user.svg">
              {{ datas.business.linkman }}　
              <img class="box-connect-phone" src="../../static/images/Normal05/phone.svg">
              {{ datas.business.linkphone }}
            </div>
            <div class="separation"></div>
            <div class="box-company-address">
              <a v-text="datas.business.baddress"></a>
              <a class="box-company-address-icon"><img class="img" src="../../static/images/Normal05/address.svg"></a>
            </div>
            <div class="separation"></div>

            <div class="box-head-two">
              <a>实时天气</a>
              <div class="box-list-rightt-box" :style="{ top: weatherTop + 'px' }">
                <div><img class="box-list-rightt-icon" :src="'../../static/images/Normal05/' + weather.icon + '.png'">
                </div>
                <div class="box-list-rightt-txt" v-text="weather.type"></div>
              </div>
            </div>
            <div class="box-list padding-box weather">
              <div class="box-list-leftt">
                <div class="box-list-leftt-count" v-text="weather.high"></div>
                <div>温度</div>
              </div>
              <div class="box-list-rightt">
                <ul>
                  <li>湿度：{{ weather.shidu }}</li>
                  <li>风速：{{ weather.fengxiang }}</li>
                  <li>空气：{{ weather.kongqi }}</li>
                </ul>
              </div>
            </div>

            <div class="separation"></div>
            <div class="map-box">
              <div id="map" class="mapmain"></div>
            </div>
          </div>

          <footer :style="{ backgroundColor: navColor }" v-text="datas.business.name"></footer>
          <div id="audio-box"></div>
        </section>
      </section>
      <!-- 结束企业版 -->




      <!-- 开始组织版 -->
      <section v-else>
        <!-- <header class="headerOne">
          <div class="header" :class="{ 'fix': headOne }"><a class="header-main" v-text="organize.org.name"></a></div>
        </header> -->

        <!-- <div class="swiper-container banner bannerOne" v-if="banner">
      	<div class="swiper-wrapper">
      		<div class="swiper-slide" v-for="(item,index) in banner" v-bind:key="index"><img :src="item"></div>
      	</div>
      	<div class="swiper-pagination"></div>
      </div> -->
        <!-- <div><img class="img" :src="organize.org.user_account.logo"></div> -->


        <div class="box" v-if="organize">
          <div class="box-bg box-radius">
            <div class="box-head">产品信息</div>
            <div class="box-list padding-box">
              <ul>
                <li class="box-list-left">商品名称：</li>
                <li class="box-list-right" v-text="organize.prodction.name"></li>
              </ul>
            </div>
          </div>
        </div>

        <!-- <div class="box">
      	<div class="box-bg box-radius">
      		<div class="box-head">商户信息</div>
      		<div class="box-list padding-box">
      			<ul>
      				<li class="box-list-left">商户名称：</li>
      				<li class="box-list-right" v-text="organize.org.name"></li>
      			</ul>
      			<ul>
      				<li class="box-list-left">商户地址：</li>
      				<li class="box-list-right" v-text="organize.org.linkaddress"></li>
      			</ul>
      		</div>
      	</div>
      </div> -->

        <div class="box" v-if="organize.batch">
          <div class="box-bg box-radius">
            <div class="box-head">质检信息</div>
            <div class="box-list customize">
              <div class="box-list-main" v-for="item in organize.batch.qc">
                <div class="box-list-title">
                  <ul>
                    <li class="box-list-left title-color" v-text="item.key"></li>
                    <li class="box-list-right">
                      <img class="box-list-right-icon" src="../../static/images/Normal05/right.svg">
                    </li>
                  </ul>
                </div>
                <div class="box-list-datas" v-if="item.value && item.value.length > 0">
                  <div v-if="item.key == '五、屠宰厂信息'">
                    <header class="headerOne">
                      <div class="header"><a class="header-main" v-text="organize.org.name"></a></div>
                    </header>
                    <div class="swiper-container banner bannerOne" v-if="banner">
                      <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in banner" v-bind:key="index"><img :src="item">
                        </div>
                      </div>
                      <div class="swiper-pagination"></div>
                    </div>
                    <div class="box-list-img" style="margin-top: 10px;">
                      <video v-if="datas.video || organize.prodction.video" id="VideoBox" class="video-js vjs-big-play-centered vjs-fluid VideoBox"
                        :poster="organize.prodction.img">
                        <source :src="organize.prodction.video" type="video/mp4">
                      </video>
                    </div>
                  </div>
                  <ul v-for="vall in item.value">
                    <li v-if="vall.ix == 0" class="box-list-left" v-text="vall.key"></li>
                    <li v-if="vall.ix == 0" class="box-list-right" v-text="vall.value"></li>
                    <li v-if="vall.ix == 1"><img class="img" :src="vall.value" /></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <header class="headerTwo">
          <div class="header" :class="{ 'fix': headTwo }" :style="{ backgroundColor: navColor }"><a class="header-main"
              v-text="datas.business.name"></a></div>
        </header>

        <div class="swiper-container banner bannerTwo" v-if="datas.focus && datas.focus_pics_is_show == 1">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in datas.focus" v-bind:key="index"><img :src="item.img">
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>

        <div class="box-main box-bg box-top">
          <div class="SearchReturn" v-if="datas.scan_count > 1">您查询的商品编码为<i class="code"
              v-text="code"></i>，此编码已被查询过，谨防假冒！</div>
          <div class="SearchReturn" v-else>你查询的编码为<i class="code" v-text="code"></i>，是 {{ datas.business.name }}
            的正牌产品，首次被查询，请放心使用!</div>
          <div class="box-list">
            <ul style="padding-bottom: 5px;">
              <li class="box-list-left">查询次数：</li>
              <li class="box-list-right" v-text="datas.scan_count"></li>
              <li class="box-list-btn" :style="{ backgroundColor: navColor }" @click="ViewMore(1)">查询记录</li>
            </ul>
            <ul>
              <li class="box-list-left">首查时间：</li>
              <li class="box-list-right" v-text="datas.scan_first_time"></li>
            </ul>
          </div>
        </div>

        <div class="box-main box-bg box-top" v-if="datas.ref && datas.ref.length > 0 && datas.ref_is_show == 1">
          <div class="btn-arr" :style="{ height: btnarrheight + 'px' }">
            <div class="btn-style" :style="{ top: item.top + 'px', left: item.left, opacity: item.opaque }"
              v-on:click="RefJump(index)" v-for="(item, index) in datas.ref" :class="item.color"
              v-if="index < 5 || isShow">
              <a v-text="item.name"></a>
              <img class="btn-icon" src="../../static/images/Normal05/right-two.svg">
            </div>
            <div class="btn-style orange-two-bg" :style="{ top: btntop + 'px', left: btnleft, opacity: btnopaque }"
              v-on:click="MoreBtn" v-if="!isShow">
              <a>查看更多</a>
              <img class="btn-icon" src="../../static/images/Normal05/plus.svg">
            </div>
          </div>
        </div>

        <!-- <div class="box-main box-bg box-top" v-if="datas.menu && datas.menu.length > 0 && datas.menu_is_show == 1">
        <div class="btn-arr">
          <div class="btn-style-two red-bg" v-for="(val,index) in datas.menu" v-on:click="MenuJump(val.url)">
          	<a v-text="val.name"></a>
          	<img class="btn-icon" src="../../static/images/Normal05/right-two.svg">
          </div>
        </div>
      </div> -->

        <div class="box-main box-bg box-top" v-if="datas.product && datas.product.introduce">
          <div class="btn-arr">
            <div class="btn-style-two red-bg" v-on:click="MenuJump(datas.product.introduce)">
              <a>查看详情</a>
              <img class="btn-icon" src="../../static/images/Normal05/right-two.svg">
            </div>
          </div>
        </div>

        <div class="box-main box-bg box-top" v-if="datas.business && datas.business_is_show == 1">
          <div class="box-head-two"><a>联系我们</a></div>
          <div class="box-company-name">
            <a>公司名称</a>
            <a v-text="datas.business.name"></a>
          </div>
          <div class="separation"></div>
          <div class="box-connect">
            <img class="box-connect-user" src="../../static/images/Normal05/user.svg">
            {{ datas.business.linkman }}　
            <img class="box-connect-phone" src="../../static/images/Normal05/phone.svg">
            {{ datas.business.linkphone }}
          </div>
          <div class="separation"></div>
          <div class="box-company-address">
            <a v-text="datas.business.baddress"></a>
            <a class="box-company-address-icon"><img class="img" src="../../static/images/Normal05/address.svg"></a>
          </div>
          <div class="separation"></div>

          <div class="box-head-two">
            <a>实时天气</a>
            <div class="box-list-rightt-box" :style="{ top: weatherTop + 'px' }">
              <div><img class="box-list-rightt-icon" :src="'../../static/images/Normal05/' + weather.icon + '.png'">
              </div>
              <div class="box-list-rightt-txt" v-text="weather.type"></div>
            </div>
          </div>
          <div class="box-list padding-box weather">
            <div class="box-list-leftt">
              <div class="box-list-leftt-count" v-text="weather.high"></div>
              <div>温度</div>
            </div>
            <div class="box-list-rightt">
              <ul>
                <li>湿度：{{ weather.shidu }}</li>
                <li>风速：{{ weather.fengxiang }}</li>
                <li>空气：{{ weather.kongqi }}</li>
              </ul>
            </div>
          </div>

          <div class="separation"></div>
          <div class="map-box">
            <div id="map" class="mapmain"></div>
          </div>
        </div>

        <div id="audio-box"></div>

        <footer :style="{ backgroundColor: navColor }" v-text="datas.business.name"></footer>
      </section>
      <!-- 结束组织版 -->

    </div>
  </div>
</template>

<script>
let self, map;
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
export default {
  name: 'Normal05',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  data() {
    return {
      code: null,
      count: 2,
      isPlay: false,
      navColor: "#5faf28",
      banner: [],
      datas: null,
      organize: {
        org: {},
        prodction: {}
      },
      Loading: {
        type: 1,
        txt: "数据请求中..."
      },
      location: null,
      headOne: false,
      headTwo: false,
      isShow: false,
      btnarrheight: 178,
      btnisAni: false,
      btntop: 122,
      btnleft: "100%",
      btnopaque: 0,
      weatherTop: 50,
      weather: {
        high: "24℃",
        shidu: "41%",
        fengxiang: "微风 1级",
        kongqi: "36 优质",
        type: "多云",
        icon: "01"
      }
    }
  },
  created() {
    self = this;

    //判断是演示还是真实码标
    if (this.$route.query.type == "demo") {
      self.GetDemoDatas(this.$route.query.pid, this.$route.query.rid);  //获取演示模板信息
    } else {
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }


  },
  mounted() {

    // 绑定滚动事件
    window.onscroll = function () {
      var name = self.$route.name;
      if (name == "Normal05") {
        var scrollT = document.documentElement.scrollTop || document.body.scrollTop;
        // if ($(".headerTwo").offset()) {
        //   var headerTwo = $(".headerTwo").offset().top;
        //   if (scrollT > 0) {
        //     self.headOne = true;
        //     self.headTwo = false;
        //   } else {
        //     self.headOne = false;
        //     self.headTwo = true;
        //   }
        //   if (scrollT > headerTwo) {
        //     self.headOne = false;
        //     self.headTwo = true;
        //   } else {
        //     self.headOne = true;
        //     self.headTwo = false;
        //   }
        // }

        //按钮动画
        if ($(".btn-arr").offset()) {
          var btnScroll = $(".btn-arr").offset().top;
          if (!self.btnisAni) {
            if (scrollT > btnScroll - 600) {
              var winw = $(window).width() / 2.1;
              let left = 0;
              for (let r in self.datas.ref) {
                if (r % 2 == 1) {
                  self.datas.ref[r].left = winw + 'px';
                } else {
                  self.datas.ref[r].left = 0;
                }
                self.datas.ref[r].opaque = 1;
              }
              self.btnopaque = 1;
              self.btnleft = winw + 'px';
              self.btnisAni = true;
            }
          }
          if (scrollT > btnScroll - 50) {
            self.weatherTop = 8;
          }
        }

      }
    }

  },
  methods: {
    GetDemoDatas(pid, rid) {
      axios.get(self.GetServerUrl(1) + "template_product/" + pid + "/" + rid)
        .then(function (response) {
          let datas = response.data.meta;
          let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息
          console.log(datas)
          if (datas.scan_count) {
            datas.scan_count = datas.scan_count;
          } else {
            datas.scan_count = 1;
          }
          datas.scan_first_time = "2017-10-31 12:12";
          datas.scan_first_address = "广东省深圳市";
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          } else {
            if (defaultDatas.ref) {
              datas.ref = JSON.parse(defaultDatas.ref);
            }
          }
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          if (datas.batch) {
            datas.batch = JSON.parse(datas.batch);
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }

          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }


          datas.activity_is_show = 1;

          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }

          //默认信息
          if (!datas.process) {
            datas.process = defaultDatas.process;
          }
          if (!datas.process_demo) {
            datas.process_demo = defaultDatas.process_demo;
          }
          if (!datas.dealer) {
            datas.dealer = defaultDatas.dealer;
          }
          self.datas = datas;
          self.$nextTick(() => {
            self.Banner(); //焦点图
            self.CreateMap(); //地图
          })

          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    GetDatas() {
      axios.get(self.GetServerUrl(1) + "query/" + self.code)
        .then(function (response) {

          let datas = response.data.meta.product_template;
          let organize = response.data.meta.distribution_template;
          let org = response.data.meta.org;
          datas.scan_count = response.data.meta.scan_count;  //扫码次数
          datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
          datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点

          //组织自定义属性
          if (org && org.customize_data) {
            self.banner.push(org.user_account.logo);
            var org_customize = JSON.parse(org.customize_data)
            for (let i in org_customize) {
              if (org_customize[i].key == "图片") {
                self.banner.push(org_customize[i].value)
              }
            }
          }

          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }

          //企业经纬度
          if (datas.business.lon_lat) {
            self.location = datas.business.lon_lat;
          }
          //焦点图
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          //自定义栏目
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);

            /*** 滑县烧鸡按钮颜色开始 ***/
            var BtnColor = ["red-bg", "yellow-bg", "orange-bg", "green-bg", "blue-bg", "orange-two-bg", "red-bg", "yellow-bg"];
            let cix = 0, left = 0, top = 10;
            for (let r in datas.ref) {
              if (cix > BtnColor.length) {
                cix = 0;
              }
              datas.ref[r].top = top;
              if (r % 2 == 1) {
                top = top + 56;
                datas.ref[r].left = '100%';
              } else {
                datas.ref[r].left = '-100%';
              }
              datas.ref[r].opaque = 0;
              datas.ref[r].color = BtnColor[cix]
              cix++
            }
            /*** 滑县烧鸡按钮颜色结束 ***/

          }
          //自定义菜单
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          //批次信息
          if (datas.batch) {
            try {
              if (datas.batch.qc) {
                var qcArr = [];
                let ix = 0;
                let qc = JSON.parse(datas.batch.qc)
                for (let i in qc) {
                  if (qc[i].ix == 2) {
                    ix++
                    qcArr[ix] = { key: qc[i].key, value: [] }
                  }
                  if (qc[i].ix != 2) {
                    if(!qcArr[ix]){
                      qcArr[ix] = [];
                    }
                    qcArr[ix].value.push(qc[i]);
                  }
                }
                qcArr.shift();
                datas.batch.qc = qcArr;
              }
            } catch (error) {
              console.error(error)
            }
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);

            //自动转换新域名
            // if(datas.video.url){
            //   let videoUrl = datas.video.url.substring(12,17);
            //   if(videoUrl == "wwmxt"){
            //     datas.video.url = self.GetVideoUrl() + datas.video.url.substring(20,datas.video.url.length)
            //   }
            // }

          }

          //组织质检信息
          if (organize.batch && organize.batch.qc) {
            var qcArr = [];
            let ix = 0;
            let qc = JSON.parse(organize.batch.qc)
            for (let i in qc) {
              if (qc[i].ix == 2) {
                ix++
                qcArr[ix] = { key: qc[i].key, value: [] }
              }
              if (qc[i].ix != 2) {
                qcArr[ix].value.push(qc[i]);
              }
            }
            qcArr.shift();
            organize.batch.qc = qcArr;
          }


          //企业主题颜色
          if (datas.business.rootid == "100400002") {
            self.navColor = "#c01027";
          }

          datas.activity_is_show = 1;
          self.datas = datas;
          organize.org = response.data.meta.org;
          self.organize = organize;

          // document.title = self.datas.business.name;  //设置页面标题
          self.$nextTick(() => {

            var hinttxt;
            if (datas.scan_count > 1) {
              hinttxt = "您查询的商品编码为" + self.code + " 此编码已被查询过 谨防假冒 本次查询次数为" + datas.scan_count + "次 首查时间为" + datas.scan_first_time;
            } else {
              hinttxt = "你查询的编码为" + self.code + " 是" + datas.business.name + "的正牌产品 首次被查询 请放心使用 首查时间为" + datas.scan_first_time
            }
            // self.speech(hinttxt);
            // window.addEventListener('touchstart', self.playAudio, false);

            self.Banner(); //焦点图

            if (datas.business_is_show == 1) {
              self.CreateMap(); //地图
            }

            if(self.organize && self.organize.prodction && self.organize.prodction.video){
              self.initVideo();
            }

            if (self.datas.video) {
              self.initVideo();
            }

            $('.box-list-title').click(function () {
              var pix = $(this).parent().index();
              $(".box-list-main").each(function () {
                var six = $(this).index();
                if (pix != six) {
                  $(this).find('.box-list-title').attr("data-active", false)
                  $(this).find('.box-list-datas').css({ height: 0 })
                  $(this).find('.box-list-right-icon').attr("src", "../../static/images/Normal05/right.svg");
                }
              })

              var state = $(this).attr("data-active");
              if (state && state != 'false') {
                $(this).attr("data-active", false)
                $(this).next().css({ height: 0 })
                $(this).find('.box-list-right-icon').attr("src", "../../static/images/Normal05/right.svg");
              } else {
                $(this).attr("data-active", true)
                var bh = $(this).next()[0].scrollHeight;
                $(this).next().css({ height: bh + "px" })
                $(this).find('.box-list-right-icon').attr("src", "../../static/images/Normal05/top.svg");
              }
            })

            //自动滚动
            setTimeout(function () {
              var headerTwo = parseInt(localStorage.getItem("wwm_scrolltop")) - 50;
              if (headerTwo) {
                $('html, body').animate({ scrollTop: headerTwo }, 0);
                localStorage.removeItem("wwm_scrolltop")
              }
            }, 100)

          })

        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    initVideo() {
      //初始化视频方法
      let myPlayer = this.$video("#VideoBox", {
        controls: true,  //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        autoplay: false,  //自动播放属性,muted:静音播放
        preload: "auto",  //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
      });
    },
    ViewMore(datas) {
      if (self.code) {
        this.$router.push({ path: "/ScanCodeRecord" }); // 模板路由跳转
      } else {
        alert("真实码标数据才能查看扫码记录！");
      }
    },
    inited(viewer) {
      self.$viewer = viewer
    },
    PreviewImgs() {
      self.$viewer.show();
      self.$viewer.update();
    },
    ClickMenu(data) {
      if (data.type != 2) {
        window.location.href = data.url;
      } else {
        this.$router.push({ path: "/qr?qr=" + data.qr });
      }
    },
    MoreBtn() {
      if (self.isShow) {
        self.btnarrheight = 178;
        self.isShow = false;
      } else {
        var refData = self.datas.ref;
        var backupRef = JSON.parse(JSON.stringify(refData));
        for (let i in refData) {
          if (i >= 5) {
            if (i % 2 == 1) {
              refData[i].left = "100%"
            } else {
              refData[i].left = "-100%"
            }
            refData[i].opaque = 0
          }
        }
        self.btnarrheight = 234;
        self.isShow = true;


        self.$nextTick(() => {
          setTimeout(function () {
            for (let i in refData) {
              if (i >= 5) {
                refData[i].left = backupRef[i].left;
                refData[i].opaque = 1
              }
            }
          }, 100)
        });


      }
    },
    Banner() {
      new Swiper('.bannerOne', {
        autoplay: {
          disableOnInteraction: false,
          delay: 5000
        },
        loop: true,
        // autoHeight: true, //高度随内容变化
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        }
      })

      new Swiper('.bannerTwo', {
        disableOnInteraction: false,
        autoplay: {
          disableOnInteraction: false,
          delay: 5000
        },
        loop: true,
        // autoHeight: true, //高度随内容变化
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        }
      })
    },
    CreateMap() {
      if (self.location) {
        let ll = self.location.split(",");
        map = new BMap.Map("map"); // 创建Map实例
        var point = new BMap.Point(ll[0], ll[1]);
        var marker = new BMap.Marker(point);
        let left = self.datas.business.name.length * 6;
        var label = new BMap.Label(self.datas.business.name, { offset: new BMap.Size('-' + left, 26) });
        label.setStyle({
          color: "black",
          border: '0px',
          fontSize: "12px",
          height: "20px",
          padding: "0 10px",
          lineHeight: "20px",
          fontFamily: "微软雅黑"
        });
        marker.setLabel(label);
        map.addOverlay(marker);
        map.centerAndZoom(point, 13); // 初始化地图,设置中心点坐标和地图级别
        map.addControl(new BMap.MapTypeControl()); //添加地图类型控件
        map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放


        let geoc = new BMap.Geocoder()
        let point = new BMap.Point(ll[0], ll[1])
        geoc.getLocation(point, function (rs) {
          let addComp = rs.addressComponents
          self.getWeather(addComp.city);
        })

      }
    },
    RefJump(ix) {
      var scrollT = document.documentElement.scrollTop || document.body.scrollTop;
      var name = self.datas.ref[ix].name;
      var datas = self.datas.ref[ix].datas;
      localStorage.setItem("wwm_scrolltop", scrollT);
      localStorage.setItem("wwm_ref", JSON.stringify({ name: name, data: datas }));
      this.$router.push({ path: "/Details" }); // 模板路由跳转
    },
    MenuJump(url) {
      window.open(url);
    },
    getWeather(city) {
      $.ajax({
        method: "GET",
        url: "https://wthrcdn.etouch.cn/weather_mini?city=" + city,
        headers: {
          Accept: "application/json; charset=utf-8",
        },
        dataType: "json",
        success: function (result, status) {
          let weather = result.data.forecast[0];
          weather.high = weather.high.substring(3, weather.length); //最高温度
          weather.low = weather.low.substring(3, weather.length); //最低温度
          weather.shidu = parseInt(weather.high.substring(0, 2)) + parseInt(weather.low.substring(0, 2)) + "%"
          weather.fengxiang = weather.fengxiang + ' 2级';
          weather.kongqi = "49 优质";

          self.weather = weather;
          if (self.weather.type == "晴") {
            self.weather.icon = "00";
          } else if (self.weather.type == "多云") {
            self.weather.icon = "01";
          } else if (self.weather.type == "阴") {
            self.weather.icon = "02";
          } else if (self.weather.type == "小雨") {
            self.weather.icon = "07";
          } else {
            self.weather.icon = "00";
          }
        }
      });
    },
    speech(txt) {
      var chtml = "";
      var zhText = encodeURI(txt);
      chtml += '<audio id="audio-main" preload="auto" autoplay="autoplay" >';
      chtml += '<source src="https://tts.baidu.com/text2audio?tex=' + zhText + '&cuid=baike&lan=ZH&ie=utf-8&ctp=1&pdt=301&vol=9&rate=32&per=0" type="audio/mpeg" />';
      chtml += '<embed src="https://tts.baidu.com/text2audio?tex=' + zhText + '&cuid=baike&lan=ZH&ie=utf-8&ctp=1&pdt=301&vol=9&rate=32&per=0" />';
      chtml += '</audio>';
      $("#audio-box").html(chtml);
    },
    playAudio(state) {
      if (!self.isPlay) {
        document.getElementById("audio-main").play();
        self.isPlay = true;
      }
    }
  }
}
</script>

<style scoped>
header {
  position: relative;
  background-color: #5faf28;
}

footer {
  color: #FFF;
  text-align: center;
  background-color: #5faf28;
  margin-top: 10px;
}

.header {
  color: #FFF;
  text-align: center;
  font-size: 19px;
  background-color: #5faf28;
  z-index: 99;
}

.headerTwo {
  margin-top: 10px;
}

.fix {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
}

.header-icon {
  width: 25px;
  position: absolute;
}

.header-icon-left {
  left: 10px;
  top: 15px;
}

.header-icon-right {
  right: 10px;
  top: 13px;
}

.header-main {
  padding: 15px 0;
  display: block;
  text-align: center;
  margin-left: 35px;
  width: calc(100% - 70px);
}

.headerOne {
  height: 55px;
}

.headerOne .header-main,
.headerTwo .header-main {
  width: calc(100% - 30px);
  margin-left: 15px;
}

footer {
  padding: 8px 0;
  font-size: 15px;
}

body {
  color: #333;
  line-height: 25px;
  font-size: 15px;
  background-color: #F3F3F3;
}

i {
  font-style: normal;
}

.img {
  display: block;
  width: 100%;
}

.banner img {
  display: block;
  width: 100%;
}

.box {
  padding: 10px 10px 0 10px;
}

.box:last-child {
  padding-bottom: 10px;
}

.box-top {
  margin-top: 10px;
}

.box-main {
  padding: 10px 15px;
  overflow: hidden;
}

.box-bg {
  background: rgba(255, 255, 255, 0.8);
}

.box-radius {
  border-radius: 8px;
}

.code {
  color: #fbb214;
  padding: 0 5px;
}

.SearchReturn {
  padding: 10px 0;
  word-break: break-all;
  border-bottom: 1px solid #E9E9E9;
}

.padding-box {
  padding: 10px;
}

.box-list {
  overflow: hidden;
}

.box-list ul {
  overflow: hidden;
  position: relative;
}

.box-list ul:last-child {
  padding-bottom: 8px;
}

.box-list-btn {
  color: #FFF;
  border-radius: 50px;
  padding: 3px 10px;
  position: absolute;
  right: 0;
  top: 5px;
  font-size: 14px;
  background-color: #51B202;
}

.box-list-main {
  padding: 0 10px;
}

.box-list-main:hover {
  background-color: #F6F6F6;
}

.box-list-datas {
  height: 0;
  overflow: hidden;
  transition: all .5s ease 0s;
}

.box-list-datas ul:last-child {
  padding-bottom: 10px;
}

.box-list-left,
.box-list-right {
  float: left;
  padding-top: 12px;
  line-height: 20px;
}

.box-list-left {
  width: 80px;
  color: #666;
}

.box-list-right {
  width: calc(100% - 80px);
  position: relative;
}

.customize .box-list-left {
  width: 135px;
  line-height: 30px;
}

.box-list-title .box-list-right {
  line-height: 10px !important;
}

.customize .box-list-right {
  width: calc(100% - 135px);
  line-height: 30px;
  text-align: right;
}

.box-list-right-icon {
  width: 30px;
}

.box-head {
  padding: 10px;
  border-radius: 10px;
  border-bottom: 1px solid #F3f3f3;
  background: rgba(255, 255, 255, 0.5);
}

.btn-arr {
  overflow: hidden;
  padding-top: 10px;
  position: relative;
}

.btn-style {
  display: table;
  float: left;
  padding: 12px 0;
  color: #fff;
  border-radius: 8px;
  width: calc(50% - 12px);
  border: 1px solid #666;
  text-align: center;
  margin-bottom: 10px;
  position: absolute;
  transition: all .8s ease 0s;
}

.btn-style-two {
  padding: 12px 0;
  color: #fff;
  border-radius: 8px;
  border: 1px solid #666;
  text-align: center;
  margin-bottom: 10px;
  position: relative;
}

.btn-style-two>.btn-icon {
  top: 9px;
}

.btn-icon {
  position: absolute;
  height: 25px;
  display: table;
  right: 10px;
  top: 12.5px;
}

.red-bg {
  background-color: #ff4b45;
}

.yellow-bg {
  background-color: #f9c719;
}

.orange-bg {
  background-color: #ff9e1f;
}

.orange-two-bg {
  background-color: #ff7c4e;
}

.green-bg {
  background-color: #68c51c;
}

.blue-bg {
  background-color: #18ade5;
}

.box-head-two {
  text-align: center;
  position: relative;
}

.box-head-two a {
  display: table;
  margin: 0 auto;
  padding: 10px 0;
  font-size: 17px;
  border-bottom: 2px solid #51B202;
}

.map-box {
  height: 180px;
  background-color: #f9f9f9;
}

#map {
  height: 180px;
}

.separation {
  margin: 8px 0;
  border-bottom: 1px dashed #e3e3e3;
}

.box-list-leftt {
  float: left;
  text-align: center;
  width: 120px;
}

.box-list-rightt {
  float: left;
  color: #777;
  width: calc(100% - 120px);
}

.title-color {
  color: #333 !important;
}

.box-list-leftt-count {
  font-size: 20px;
  font-weight: bold;
  margin-top: 3px;
}

.weather {
  padding-top: 20px;
  position: relative;
}

.box-list-rightt-box {
  position: absolute;
  right: 0;
  transition: all .8s ease 0s;
}

.box-list-rightt-icon {
  width: 45px;
  display: block;
}

.box-list-rightt-txt {
  text-align: center;
  color: #999;
  font-size: 15px;
}

.box-company-name {
  padding-top: 20px;
  line-height: 25px;
}

.box-company-name a:first-child {
  color: #51B202;
  margin-right: 8px;
}

.box-connect {
  overflow: hidden;
  line-height: 25px;
  word-break: break-all;
}

.box-connect-user {
  width: 25px;
  position: relative;
  top: 5px;
}

.box-connect-phone {
  height: 22px;
  top: 4px;
  position: relative;
}

.box-company-address {
  line-height: 25px;
  position: relative;
}

.box-company-address-icon {
  width: 24px;
  right: 0;
  top: 0;
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/view/Normal05.vue